// pages/PrivacyPolicy.jsx
import React, {useEffect, useState} from 'react';
import {motion} from 'framer-motion';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PolicyHeroBit from '../components/legal/PolicyHeroBit';
import PolicySection from '../components/legal/PolicySection';

const PrivacyPolicy = () => {

    const [isScrolled, setIsScrolled] = useState(false);

    // Scroll to top when page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const sections = [
        {
            title: "Our Commitment to Your Privacy",
            content: [
                "At KROMAIC, we believe trust is the foundation of every relationship. This Privacy Policy outlines how we collect, use, and protect your personal information, maintaining the same standard of care we apply to our formulations.",
                "We are committed to transparency and giving you control over your personal data. This policy complies with international standards including GDPR, CCPA, and other global privacy regulations."
            ]
        },
        {
            title: "Information We Collect",
            content: [
                "We collect information you provide directly: name, email address, shipping address, payment information, and preferences.",
                "We automatically collect certain information: device information, IP address, browser type, and usage data through cookies and similar technologies.",
                "We may receive information from third parties, such as social media platforms when you interact with us through those services."
            ]
        },
        {
            title: "How We Use Your Information",
            content: [
                "To process and fulfill your orders with precision",
                "To personalize your experience with KROMAIC",
                "To communicate about products, offers, and rituals that may interest you",
                "To improve our website, products, and services",
                "To comply with legal obligations and protect our rights"
            ]
        },
        {
            title: "Data Security & Protection",
            content: [
                "We implement industry-standard security measures including encryption, secure servers, and regular security assessments.",
                "Your payment information is processed through PCI-compliant payment processors—we never store complete payment card details.",
                "We retain your personal information only as long as necessary for the purposes outlined in this policy."
            ]
        },
        {
            title: "Your Rights & Choices",
            content: [
                "You may access, correct, or delete your personal information through your account settings.",
                "You may opt out of marketing communications at any time.",
                "You may request a copy of your personal data or request its deletion, subject to legal requirements.",
                "You may disable cookies through your browser settings, though this may affect your experience."
            ]
        }
    ];

    return (
        <div className="min-h-screen bg-ivory">
            <div
                className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                    isScrolled
                        ? 'bg-white/100 backdrop-blur-xl shadow-soft'
                        : 'bg-transparent'
                }`}
            >
                <Navbar/>
            </div>


            <motion.main
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                exit={{opacity: 0}}
                transition={{duration: 0.8}}
            >

                <PolicyHeroBit
                    title="Privacy Policy"
                    description="Transparency and trust in every interaction"
                />


                {/* Policy Content Section */}
                <section className="py-16 bg-ivory">
                    <div className="container mx-auto px-6 lg:px-12">
                        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-soft p-8 md:p-12">
                            {sections.map((section, index) => (
                                <PolicySection
                                    key={index}
                                    title={section.title}
                                    content={section.content}
                                    last={index === sections.length - 1}
                                />
                            ))}

                            <motion.div
                                initial={{opacity: 0}}
                                whileInView={{opacity: 1}}
                                viewport={{once: true}}
                                transition={{duration: 1}}
                                className="pt-16"
                            >
                                <h3 className="font-cormorant text-2xl text-charcoal mb-6">
                                    Contact Our Privacy Team
                                </h3>
                                <p className="font-poppins text-charcoal/80 mb-8">
                                    For privacy-related inquiries, please contact our Data Protection Officer:
                                </p>
                                <motion.a
                                    whileHover={{scale: 1.02}}
                                    whileTap={{scale: 0.98}}
                                    href="mailto:privacy@kromaic.com"
                                    className="inline-block px-8 py-3 bg-sage-green text-white font-poppins rounded-full hover:bg-sage-green/90 transition-all duration-300"
                                >
                                    privacy@kromaic.com
                                </motion.a>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </motion.main>

            {/* Footer at the bottom */}
            <Footer/>
        </div>
    );
};

export default PrivacyPolicy;